<mat-accordion>
  <mat-expansion-panel disabled
    class="add">
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (hasDienstToAdd()) {
          <span>Nieuwe dienst</span>
        }
        @if (!hasDienstToAdd()) {
          <span>Geen diensten meer</span>
        }
      </mat-panel-title>
      <mat-panel-description>
        <button mat-icon-button
          (click)="onAddClick()"
          [disabled]="!hasDienstToAdd()">
          <mat-icon>add</mat-icon>
        </button>
      </mat-panel-description>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
  @if (zones$ | async; as zones) {
    @for (clientDienst of clientDiensten; track clientDienst) {
      <zah-client-dienst
        [zones]="zones"
        [clientDienst]="clientDienst"
        [dienst]="diensten.getDienst(clientDienst.getId())"
        [expanded]="isExpanded(clientDienst)"
        (deleteClicked)="onDeleteClick(clientDienst)">
      </zah-client-dienst>
    }
  }

</mat-accordion>
